import {ajax} from '../../common/utils.js';
import {SHOW_UPDATE_RECURRING_MODAL, SET_RECURRING_ORDER_DATA, SET_RECURRING_ITEM} from "../../actions/actionTypes";
import {fetchingData, errorFetching} from "../common/fetchingActions";
import {FetchingTypes} from '../../common/constants';
import {changeItemQuantity} from "./itemCardActions";

export function setShowUpdateRecurringModal(showUpdateRecurringModal) {
    return {
        type: SHOW_UPDATE_RECURRING_MODAL,
        showUpdateRecurringModal
    }
}

export function setRecurringOrderData(data) {
    return {
        type: SET_RECURRING_ORDER_DATA,
        data
    }
}
export function recurringOrderParser(recurringOrder, nextDeliveryDate) {
    if(!recurringOrder) {
        return null;
    }
    let items = [];
    const boxItems = recurringOrder.boxItems||[];
    for(let i=0; i< boxItems.length;i++){
        let item = recurringOrder.items[i];
        const schedule = recurringOrder.farmSchedules[recurringOrder.boxItemsSchedules[i]];
        item["schedule"] = schedule;
        item["quantity"] = recurringOrder.boxItemsQuantities[i];
        item["isItemNotPartOfOrder"] = !schedule.dates.includes(nextDeliveryDate);
        item["isRecurring"] = true;
        items.push(item);
    }
    recurringOrder["items"] = items;
    return recurringOrder;
}

export function setRecurringOrderItemService(recurringOrderItem) {
    return function(dispatch, getState){
        const state = getState();
        const fetchUrl = '/dispatcher/RecurringOrderItemService.setRecurringOrderItemService';
        const data = {
            memberKey: state.memberDetails.key,
            recurringOrderItem
        };
        dispatch(fetchingData(FetchingTypes.SET_RECURRING_ORDER));
        return ajax(fetchUrl, data)
            .then(json => {
                if(json.error) {
                    throw json.error;
                }
                dispatch(setShowUpdateRecurringModal(false));
            })
            .catch(error => {
                dispatch(errorFetching(error));
            })
    }
}

export function removeRecurringOrderItemService(recurringOrderItemKey) {
    return function(dispatch, getState){
        const state = getState();
        const fetchUrl = '/dispatcher/RecurringOrderItemService.setRecurringOrderItemService';
        const data = {
            memberKey: state.memberDetails.key,
            recurringOrderItemKey
        };
        dispatch(fetchingData(FetchingTypes.SET_RECURRING_ORDER));
        return ajax(fetchUrl, data)
            .then(json => {
                if(json.error) {
                    throw json.error;
                }
                dispatch(setShowUpdateRecurringModal(false));
            })
            .catch(error => {
                dispatch(errorFetching(error));
            })
    }
}

export function setRecurringItem(item, updateSchedule) {
    return{
        type: SET_RECURRING_ITEM,
        item,
        updateSchedule
    }
}

export function addRecurringItemsToOrder(deliveryDate) {
    return function (dispatch, getState) {
        const state = getState();
        const recurringOrder = state.recurringOrder;
        const activeOrder = state.orderStatus.activeOrder;
        if(!activeOrder && recurringOrder) {
            recurringOrder.items.map(function (item) {
                const itemExists = (getState().itemsList||{}).hasOwnProperty(item.key);
                if(itemExists && item.schedule.dates.includes(deliveryDate)) {
                    dispatch(changeItemQuantity(item, item.quantity, 0, state.creditsData));
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/store/recurringOrderActions.js